import React from 'react';

import './RoleTag.scss';

interface Props {
  children?: React.ReactNode;
  color: string;
}

const RoleTag: React.FC<Props> = ({ color, children }) => {
  return (
    <div className="roleTag nowrap" style={{ backgroundColor: color }}>
      {children}
    </div>
  );
};

export default RoleTag;
